import { render, staticRenderFns } from "./CaSa.vue?vue&type=template&id=32a7cd6c&scoped=true&"
import script from "./CaSa.vue?vue&type=script&lang=js&"
export * from "./CaSa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a7cd6c",
  null
  
)

export default component.exports